import { useGetCountriesData } from "../../../api/static-data";
import ConfirmModal from "../../../components/confirmViewModal/ConfirmModal";
import { TwScope } from "../../../components/ui/TwScope";
import SupplierDetailsModal from "../supplierDetails/SupplierDetailsModal";
import SupplierEditModal from "../supplierEdit/SupplierEditModal";
import SupplierListHeader from "./components/SupplierListHeader";
import SupplierListPagination from "./components/SupplierListPagination";
import SupplierListToolbar from "./components/SupplierListToolbar";
import SupplierTable from "./components/SupplierTable";
import { useSupplierListViewModel } from "./hooks/useSupplierListViewModel";

/**
 * Tailwind rebuild of the Supplier grid, following the same pattern as
 * `ProductListNew` (src/screens/lcaProduct/productList/ProductListNew.tsx):
 * a `TwScope` page shell composing header/toolbar/table/pagination, all
 * state/data-fetching living in `useSupplierListViewModel`. Gated behind
 * `ENABLE_LCA_SUPPLIER_UI_REDESIGN` — see src/routes/supplierRoutes.tsx for
 * the switch against the untouched legacy `SupplierList`
 * (src/screens/supplier/supplierList/SupplierList.tsx).
 *
 * No "+ Register New Supplier" entry point anywhere — explicitly out of
 * scope for this release (see `SupplierListHeader`).
 */
const SupplierListNew = () => {
  const vm = useSupplierListViewModel();
  const { data: countriesData } = useGetCountriesData();

  return (
    <TwScope className="tw-min-h-full tw-bg-white tw-p-6">
      <SupplierListHeader />

      <SupplierListToolbar
        searchKey={vm.searchKey}
        onSearchChange={vm.setSearchKey}
        refetchWithFilters={vm.refetchWithFilters}
      />

      <SupplierTable
        rows={vm.rows}
        isLoading={vm.isRowsLoading || vm.isCountriesLoading}
        countryNameById={vm.countryNameById}
        onView={vm.openDetailsModal}
        onEdit={vm.openEditModal}
        onDelete={vm.openDeleteConfirm}
      />

      <SupplierListPagination
        totalCount={vm.totalCount}
        pageNumber={vm.pageNumber}
        totalPages={vm.totalPages}
        onPageChange={vm.handlePagination}
      />

      <SupplierEditModal
        visibleModal={!!vm.supplierEdit}
        supplier={vm.supplierEdit}
        closeModal={vm.closeEditModal}
        onSuccessEdit={vm.onSuccessEdit}
      />

      <SupplierDetailsModal
        visibleModal={!!vm.supplierDetails}
        supplier={vm.supplierDetails}
        setVisibleModal={vm.closeDetailsModal}
        countriesData={countriesData}
        setVisibleEdit={vm.navigateDetailsToEdit}
      />

      <ConfirmModal
        viewModal={vm.visibleDeleteConfirm}
        closeModal={vm.closeDeleteConfirm}
        cancel={vm.closeDeleteConfirm}
        approve={vm.confirmDelete}
        title="Delete Supplier Data"
        subTitle="Are you sure you want to delete your supplier data?"
      />
    </TwScope>
  );
};

export default SupplierListNew;
